const routes = Object.freeze({
  home: '/',
  dashboard: '/dashboard',
})

export default routes
